import React from 'react';

import { Paths } from '../../../../shared/paths';
import { ITraining } from '../../../../types/interfaces/training';
import TrainingShareAccessTab from '../../shared/training-share-access-tab/TrainingShareAccessTab';

interface IFinishedTrainingAccessProps {
  training: ITraining | undefined;
  trainingId: string;
  isFetching: boolean;
}

export default function FinishedTrainingAccess(
  props: IFinishedTrainingAccessProps,
) {
  const { trainingId, ...rest } = props;
  return (
    <TrainingShareAccessTab
      {...rest}
      trainingId={trainingId}
      redirectTo={Paths.trainings.toFinishedSummaryId(trainingId)}
    />
  );
}
